import Axios from 'axios'
import { toggleDefaultData } from './toggle'
var qs = require('qs')

const uploadFile = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  sendFile (file, id, glucose, glycatedHemoglobin, collectDate) {
    glucose = glucose ? '&glucose=' + glucose : ''
    glycatedHemoglobin = glycatedHemoglobin ? '&glycatedHemoglobin=' + glycatedHemoglobin : ''
    collectDate = collectDate ? '&collectDate=' + collectDate : ''

    let query = '?' + glucose + glycatedHemoglobin + collectDate

    query = query.replace('?&', '?')

    let formData = new FormData()
    formData.append('name', file)

    return this.axios().post('/order/upload-profile-exams/' + id + query, formData)
  },

  getFilesSent (startDate, endDate, idLaboratory, stateList) {
    return this.axios().get('/order/upload-profile-exams/files-sent', {
      params: {
        startDate: startDate,
        endDate: endDate,
        idLaboratory: idLaboratory,
        stateList: stateList
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, { indices: false })
      }
    })
  },

  updateOrderDuplicatedBeforeTransfered (idOrder) {
    return this.axios().post('/order/validate-order/' + idOrder)
  },

  updateOrderDuplicatedAfterTransfered (order) {
    const toggleData = toggleDefaultData()
    return this.axios().put('/order/maintenance/upload/', order, {
      params: {
        asyncBatch: toggleData?.feature.nonSegregatedBatchList
      }
    })
  },

  deleteOrderDuplicated (idOrder, exams) {
    return this.axios().delete('/order/' + idOrder + '/exam', { data: exams })
  },

  deleteFile (id) {
    return this.axios().delete('/order/upload-profile-exams/files-removal', {
      params: {
        idFile: id
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, { indices: false })
      }
    })
  }
}

export default uploadFile
